import * as React from 'react';
import Paper from '@mui/material/Paper';
import { useParams } from 'react-router-dom';
import { EditorSwitch, useEditorChoice } from '../../features/stackBuilder';
import OfferBlockBuilder from './OfferBlockBuilder/OfferBlockBuilder';
import OfferBlockDetails from './OfferBlockDetails/OfferBlockDetails';

/**
 * The one place the classic and new offer block editors meet; each person's Classic/New choice
 * picks one. Retiring the classic editor means deleting OfferBlockDetails/ (and the components/
 * only it uses) and rendering OfferBlockBuilder directly here. The classic screen is left untouched,
 * so its switch floats over the bottom-left corner.
 */
export default function OfferBlockEditorRoute() {
  const [choice] = useEditorChoice('offerBlock');
  const { offerBlockId } = useParams();
  if (choice === 'stack') return <OfferBlockBuilder key={offerBlockId ?? 'create'} />;
  return (
    <>
      <OfferBlockDetails key={offerBlockId ?? 'create'} />
      <Paper
        elevation={6}
        sx={{
          position: 'fixed',
          left: 16,
          bottom: 16,
          zIndex: (theme) => theme.zIndex.speedDial,
          p: 0.5,
          borderRadius: 2,
        }}
      >
        <EditorSwitch screen='offerBlock' confirmLoss />
      </Paper>
    </>
  );
}
